module.exports = __webpack_public_path__ + "static/media/blur-purple-1.b93f26db.svg";